import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import {
  ShowTableTampilBiayaKelompok,
  ShowTableTampilBidAngsuranKelompok,
  ShowTableTampilPenerimaanAngsuranKelompok,
} from "../../../components/ShowTable";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, ButtonGroup } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilAngsuranKelompok = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const { id, idAngsuranKelompok } = useParams();
  const [no, setNo] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");
  const [tglBayar, setTglBayar] = useState("");
  const [total, setTotal] = useState("");
  const [bayar, setBayar] = useState("");
  const [isPost, setIsPost] = useState("");

  const [penerimaanAngsuranKelompoks, setPenerimaanAngsuranKelompoks] =
    useState([]);
  const [bidAngsuranKelompoks, setBidAngsuranKelompoks] = useState([]);
  const [biayaKelompoks, setBiayaKelompoks] = useState([]);

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  let today = new Date();
  let isEditableManager = user.tipeUser !== "ADMIN" && isPost === false;
  let isEditableAdmin = true;
  let isEditable = isEditableManager || isEditableAdmin;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getAngsuranKelompokById();
  }, []);

  const getAngsuranKelompokById = async () => {
    if (id) {
      const response = await postRequest(
        `/angsuranKelompoks/${idAngsuranKelompok}`,
        {},
        navigate,
        dispatch,
      );
      setNo(response.data.no);
      setTglJatuhTempo(formatDate(response.data.tglJatuhTempo));
      setAngPerBulan(response.data.angPerBulan.toLocaleString("de-DE"));
      setTglBayar(response.data.tglBayar && formatDate(response.data.tglBayar));
      setTotal(response.data.total.toLocaleString("de-DE"));
      setBayar(response.data.bayar.toLocaleString("de-DE"));
      setIsPost(response.data.isPost);

      const response2 = await postRequest(
        `/penerimaanAngsuranKelompoksByAngsuranKelompok`,
        {
          angsuranKelompokId: idAngsuranKelompok,
        },
        navigate,
        dispatch,
      );
      setPenerimaanAngsuranKelompoks(response2.data);

      const response3 = await postRequest(
        `/bidsByAngsuranKelompok`,
        {
          angsuranKelompokId: idAngsuranKelompok,
        },
        navigate,
        dispatch,
      );
      setBidAngsuranKelompoks(response3.data);

      const response4 = await postRequest(
        `/biayaAngsuranKelompoksByAngsuranKelompok`,
        {
          angsuranKelompokId: idAngsuranKelompok,
        },
        navigate,
        dispatch,
      );
      setBiayaKelompoks(response4.data);
    }
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Arisan</h3>
      <h5 style={{ fontWeight: 400 }}>Detail Angsuran Kelompok</h5>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate(`/daftarKelompok/kelompok/${id}`)}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={deleteButtonContainer}>
        {isEditable && (
          <ButtonGroup variant="contained">
            <Button
              color="primary"
              startIcon={<EditIcon />}
              sx={{ textTransform: "none" }}
              onClick={() => {
                navigate(
                  `/daftarKelompok/kelompok/${id}/angsuran/${idAngsuranKelompok}/edit`,
                );
              }}
            >
              Ubah
            </Button>
          </ButtonGroup>
        )}
      </Box>
      <hr />
      <Card>
        <Card.Header>Detail Angsuran Kelompok</Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={no} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tg. Jatuh Tempo :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={tglJatuhTempo} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Setoran/Bulan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={angPerBulan} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Bayar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={tglBayar} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Total :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={total} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Bayar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={bayar} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <Card style={{ marginTop: 10 }}>
        <Card.Header>Penerimaan Setoran</Card.Header>
        <Card.Body>
          <Box sx={tableContainer}>
            <ShowTableTampilPenerimaanAngsuranKelompok
              currentPosts={penerimaanAngsuranKelompoks}
            />
          </Box>
        </Card.Body>
      </Card>

      <Card style={{ marginTop: 10 }}>
        <Card.Header>Bid Peserta</Card.Header>
        <Card.Body>
          <Box sx={tableContainer}>
            <ShowTableTampilBidAngsuranKelompok
              currentPosts={bidAngsuranKelompoks}
            />
          </Box>
        </Card.Body>
      </Card>

      <Card style={{ marginTop: 10 }}>
        <Card.Header>Biaya</Card.Header>
        <Card.Body>
          <Box sx={tableContainer}>
            <ShowTableTampilBiayaKelompok currentPosts={biayaKelompoks} />
          </Box>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TampilAngsuranKelompok;

const deleteButtonContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
